// import { WorkYearProductionModel } from '../referential/work-year-production.model';
import { BasicModel } from '../basic.model';
import { WorkYearProductionModel } from '../referential/work-year-production.model';
import { ContractWork2Model } from './contract-work2.model';

export class ContractWorkModel {

  public id: number;
  public idInSession: number;
  public selected: any = new BasicModel();
  public workCodeMilo: string;
  public miloCode: string;
  public completeTitle: string;
  public title: string;
  public titleVO: string;
  public titleWork: string;
  public yearOfProduction: string;
  public workYearProductLabel: string;
  public action: string;
  public contractId: number;
  public workRefId: number;
  public idWork: number;
  public financialAmount: number;
  public checked: boolean = false;
  public relatedWorks: ContractWork2Model[] = [];
  public included: BasicModel[] = [];
  public excluded: BasicModel[] = [];

  constructor() {}

  public getAllIdExcluded(): number[] {
    return this.excluded.map((x) => x.id);
  }
  public fromJSON(json) {
    for (let propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
